import { DiseñoCurricularI } from "interfaces/DiseñoCurricular";
import { infoFetchGetDiseñoCurricularI } from "./diseñoCurricular";
import { infoFetchGetNormativaI, makeNormativa } from "./normativa";
import { infoFetchGetTituloI, makeTitulo } from "./titulo";
import { PlanEstudioI } from "interfaces/PlanEstudio";
import { makeDiseñoCurricular } from "dtos/diseñoCurricular";
import { NormativaI } from "interfaces/Normativa";
import { TituloI } from "interfaces/Titulo";
import { AlcanceI } from "interfaces/Alcance";
import { infoFecthOrientacionI, makeOrientacion } from "./orientaciones";
import { OrientacionI } from "interfaces/Orientacion";
import { Certificaciones } from "../screens/Certificaciones/Certificaciones";
import { infoFecthCertificacionI, makeCertificacion } from "./certificacion";
import { CertificacionI } from "interfaces/Certificacion";
import { infoFetchEspecialidadI, makeEspecialidad } from "./especialidad";
import { EspecialidadI } from "interfaces/especialidad";
import { CombinatoriaI } from "interfaces/Combinatoria";
import { infoFetchGetCombinatoriaI, makeCombinatoria } from "./combinatoria";

export interface infoFetchGetPlanesEstudioI {
  id: number | string;
  cantidad_anios: number;
  descripcion: string;
  disenioCurricular: infoFetchGetDiseñoCurricularI;
  fecha_publicacion: Date;
  nombre: string;
  normativas: infoFetchGetNormativaI[];
  titulos: infoFetchGetTituloI[];
  alcance: AlcanceI;
  orientaciones: infoFecthOrientacionI[];
  certificaciones: infoFecthCertificacionI[];
  especialidades: infoFetchEspecialidadI[];
  combinatorias: infoFetchGetCombinatoriaI[];
  aplicaValidezNacional: boolean;
}

class PlanEstudio implements PlanEstudioI {
  id: number | string;
  cantidad_anios: number;
  descripcion: string;
  disenio_curricular: DiseñoCurricularI;
  fecha_publicacion: Date;
  nombre: string;
  normativas: NormativaI[];
  titulos: TituloI[];
  alcance: AlcanceI;
  orientaciones: OrientacionI[];
  certificaciones: CertificacionI[];
  especialidades: EspecialidadI[];
  combinatorias: CombinatoriaI[];
  aplicaValidezNacional: boolean;

  constructor(dto: infoFetchGetPlanesEstudioI) {
    this.id = dto.id;
    this.nombre = dto.nombre;
    this.cantidad_anios = dto.cantidad_anios;
    this.descripcion = dto.descripcion;
    this.alcance = dto.alcance;
    this.disenio_curricular = makeDiseñoCurricular(dto.disenioCurricular);
    this.fecha_publicacion = new Date(dto.fecha_publicacion);
    this.normativas = dto.normativas.filter((ctR) => ctR != null).map((ctR) => makeNormativa(ctR));
    this.titulos = dto.titulos.filter((ctR) => ctR != null).map((ctR) => makeTitulo(ctR));
    this.orientaciones = dto.orientaciones.filter((ctR) => ctR != null).map((ctR) => makeOrientacion(ctR));
    this.certificaciones = dto.certificaciones.filter((ctR) => ctR != null).map((ctR) => makeCertificacion(ctR));
    this.especialidades = dto.especialidades.filter((ctR) => ctR != null).map((ctR) => makeEspecialidad(ctR));
    this.combinatorias = dto.combinatorias.filter((ctR) => ctR != null).map((ctR) => makeCombinatoria(ctR));
    this.aplicaValidezNacional = dto.aplicaValidezNacional;
  }
}

export const makePlanEstudio = (infoFetch: infoFetchGetPlanesEstudioI) => {
  return new PlanEstudio(infoFetch);
};
